module.exports = __webpack_public_path__ + "b61238966fb00992158d70408275c8bf.glb";